import React from "react";
import { connect } from "react-redux";
import API from "../../helpers/endpointservice";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import Chart from "react-apexcharts";
import axios from "axios";
import LoaderVisible from "../../helpers/loader";
import Select from "react-select";
import Pagination from 'react-js-pagination';
import LoaderFailed from "../../helpers/loaderFailed";
import PaginationComponent from "../../helpers/Pagination";
import { logoutFunction } from "../../custom/logoutFunction";
import { colors } from "../../helpers/Constants"
import swal from "sweetalert";
// import CommonIcon from "../../helpers/icons";
import CommonFilterModal from "../common/commonFilterModal";
import SkillMatrixFilter from "../common/slillMatrixFilterModal";
import InfoIcon from '@mui/icons-material/Info';

class Skillmatrix extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // isRequestFailed: false,
      isRequestLoader: false,
      isFieldEmpty: false,
      isSearch: false,
      pageNewCount: false,
      paginListMainRole: [{ "label": "20", "value": 20 }],
      pagingListCommitteeRole: [{ "label": "20", "value": 20 }],
      proficiencyExpectedValue: "",
      proficiencyExpectedId: 0,
      proficiencyValue: "",
      proficiencyExpectedNameEditShow: "",
      JobNameValue: "",
      jobNameEditShow: "",
      skillNameValue: "",
      skillId: 0,
      skillNameEditShow: "",
      LevelNameValue: "",
      levelNameEditShow: "",
      LevelId: 0,
      proficiencyNameEditShow: "",
      proficiencyId: 0,
      pageCountCr: 20,
      pageCountMr: 20,
      currentPageCr: 1,
      currentPageMr: 1,
      perPageCr: 20,
      perPageMr: 20,
      order: "asc",
      userId: 34,
      order1: "asc",
      pageCount: 20,
      perPage: 0,
      sortBy: "mastery",
      sortBy1: "mastery",
      searchRole: "",
      options: {
        dataLabels: {
          enabled: true,
          formatter: function (val, option) {
            if (option?.w?.globals?.initialSeries?.length == 6) {
            } else {
              return val.toFixed(2) + "%"
            }
          },
        },
        legend: false,
        labels: ["Master", "Competent", "Learning", "Novice", 'NA', "No records"],
        colors: [colors.GREEN, colors.BLUE, colors.ORANGE, colors.YELLOW, colors.BROWN, colors.GREY],
        stroke: {
          width: 0
        },
        tooltip: {
          enabled: true, shared: true,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          }
        },
      },
      paginglist: [{ "label": "5", "value": 5 }, { "label": "10", "value": 10 }, { "label": "20", "value": 20 }, { "label": "50", "value": 50 }],
      paginglistDefault: [{ "label": "20", "value": 20 }],
      series: [67, 18, 11, 20],
      graphDataValue: false,
      isMobile: false,
      iswebMobile: false,
      isMobile450: false,
      isMobile350: false,
      isMobile650: false,
      isMobile900: false,
      isPieChart: false,
      height: 0,
      width: 0,
      searchData: {},
      mainRoleBorder: true,
      supportroleBorder: false,
      searchMainSupportRoles: {
        "job": "",
        "jobGroup": "",
        "skillId": 0,
        "skill": "",
        "level": "",
        "proficiency": "",
        "proficiencyId": 0,
        "levelId": 0,
        "proficiencyExpectedId": 0,
        "proficiencyExpected": "",
        "courseProvider": ""
      }
    };
  }
  componentDidMount() {
    this.state.isRequestLoader = true;
    // $("#piechart").replaceWith("rect")
    let user = localStorage.getItem("UserId");
    let Rolevalue = localStorage.getItem("Role").split(",")[0];
    this.state.userId = parseInt(user);
    this.state.currentUser = Rolevalue;
    this.getSkillOverview();
    this.getMainRoleSkillMatrix();
    // this.getCommitteeRoleSkillMatrix();
    // this.getSkillsList();
    // this.getProficiencyList();
    // this.getLevelList();
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
  }

  // getSkillsList = () => {
  //   let apiUrl = `${API.GET_SKILLS}`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.skillsList = res?.data?.values.map((skill) => {
  //           return {
  //             value: skill.id + "," + skill.skillName,
  //             label: (
  //               <>
  //                 <span>{skill.skillName}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       logoutFunction(error?.response?.status);
  //     });
  // };

  // getProficiencyList = () => {
  //   let apiUrl = `${API.GET_PROFICIENCY}`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.proficiencyList = res?.data?.map((proficiency) => {
  //           return {
  //             value: proficiency.id + "," + proficiency.name,
  //             label: (
  //               <>
  //                 <span>{proficiency.name}</span>
  //               </>
  //             ),
  //           };
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       logoutFunction(error?.response?.status);
  //     });
  // };

  // getLevelList = () => {
  //   let apiUrl = `${API.GET_LEVEL}`;
  //   axios({
  //     method: "GET",
  //     url: apiUrl,
  //   })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         this.state.levelList = res?.data?.values.map((level) => {
  //           return {
  //             value: level.id + "," + level.name,
  //             label: (
  //               <>
  //                 <span>{level.name}</span>
  //               </>
  //             ),
  //           };
  //         }); 
  //       }
  //     })
  //     .catch((error) => {
  //       logoutFunction(error?.response?.status);
  //       console.log(error);
  //     });
  // };

  getSkillOverview = () => {
    // this.state.isRequestLoader = true;
    this.state.options.labels = [];
    this.state.options.colors = [];
    this.state.series = [];
    this.setState({})
    let apiUrl = `${API.GET_SKILL_OVERVIEW_MATRIX}?userId=${this.state.userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.master > 0 || res.data.competent > 0 || res.data.novice > 0 || res.data.na > 0 || res.data.learning > 0) {
            let color = Object.keys(res.data);
            color.map((item, index) => {
              if (item == "master") {
                this.state.options.labels.push('Master')
                this.state.options.colors.push(colors.GREEN)
                this.state.series.push({
                  "label": res.data.master,
                  "description": res.data.masterProficiencyDescription
                })
                this.setState({});
              } else if (item == "competent") {
                this.state.options.labels.push("Competent")
                this.state.options.colors.push(colors.BLUE)
                this.state.series.push({
                  "label": res.data.competent,
                  "description": res.data.competentProficiencyDescription
                })
                this.setState({});
              } else if (item == "learning") {
                this.state.options.labels.push("Learner")
                this.state.options.colors.push(colors.ORANGE)
                this.state.series.push({
                  "label": res.data.learning,
                  "description": res.data.learningProficiencyDescription
                })
                this.setState({});
              } else if (item == "novice") {
                this.state.options.labels.push("Novice")
                this.state.options.colors.push(colors.YELLOW)
                this.state.series.push({
                  "label": res.data.novice,
                  "description": res.data.noviceProficiencyDescription
                })
                this.setState({});
              } 
              // else if (item == "na") {
              //   this.state.options.labels.push("NA")
              //   this.state.options.colors.push(colors.BROWN)
              //   this.state.series.push({
              //     "label": res.data.na,
              //     "description": res.data.naProficiencyDescription
              //   })
              // }
              this.setState({ isPieChart: true, graphDataValue: true })
            }
            )
          }
          else {
            this.state.options.labels.push("No records")
            this.state.options.colors.push(colors.GREY)
            // this.state.series.push()
            this.setState({ graphDataValue: false, isPieChart: true })
          }
        }
      })
      .catch((error) => {
        console.log(error);
        // this.state.isRequestFailed = true;
        this.state.isRequestLoader = false;
        logoutFunction(error?.response?.status);
        swal("Error!", "Something went wrong. Please try again.", "warning");
        // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })

      })
  };

  fetchPaginationList = (currentPage, perPage) => {
    this.state.isRequestLoader = false;
    if (this.state.mainRoleBorder) {
      this.setState(
        {
          currentPageMr: currentPage,
          perPageMr: perPage,
          order: "asc",
        },
        () => {
          this.getMainRoleSkillMatrix();
        }
      );
    } else if (this.state.supportroleBorder) {
      this.setState(
        {
          currentPageCr: currentPage,
          perPageCr: perPage,
          order1: "asc",
        },
        () => {
          this.getCommitteeRoleSkillMatrix();
        }
      );
    }

  };

  getMainRoleSkillMatrix = (obj) => {
    this.setState({
      isRequestLoader: true
    });
    let apiUrl = `${API.GET_SKILL_MATRIX}?userId=${this.state.userId}&role=mainrole&sortBy=${this.state.sortBy}&isSortAscending=${this.state.order == "asc" ? true : false}&pageNumber=${this.state.currentPageMr}&pageSize=${this.state.perPageMr}`;
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.searchData
      data: obj
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.isRequestLoader = false;
          this.state.skillMatrixList = res.data.values;
          this.state.pageCountMr = res.data.totalCount;
          this.setState({});
          this.setState({
            isRequestLoader: false
          })
          // {
          //   if (this.state.perPageMr > 5) {
          //     $(document).ready(function () {
          //       if ((res.data.totalCount > 5) && (this.state.perPageMr > 5)) {
          //         $('#myTable').addClass('add-scroll');
          //       }
          //     });
          //   }
          //   else {
          //     $('#myTable').removeClass('add-scroll');
          //   }
          // }
        } else {
          this.setState({
            isRequestLoader: false
          })
        }
      })
      .catch((error) => {
        console.log(error);
        // this.state.isRequestFailed = true;
        this.state.isRequestLoader = false;
        logoutFunction(error?.response?.status);
        swal("Error!", "Something went wrong. Please try again.", "warning");
        // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
      });
  };

  getCommitteeRoleSkillMatrix = (obj) => {
    this.setState({
      isRequestLoader: true
    })
    let apiUrl = `${API.GET_SKILL_MATRIX}?userId=${this.state.userId}&role=supportrole&sortBy=${this.state.sortBy1}&isSortAscending=${this.state.order1 == "asc" ? true : false}&pageNumber=${this.state.currentPageCr}&pageSize=${this.state.perPageCr}`;
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.searchData
      data: obj
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.supportingRolesList = res.data.values;
          this.state.pageCountCr = res.data.totalCount;
          this.state.isRequestLoader = false;
          this.setState({});
          this.setState({
            isRequestLoader: false
          })
          // {
          //   if (this.state.perPageCr > 5) {
          //     $(document).ready(function () {
          //       if (res.data.totalCount > 5) {
          //         $('#myCommitteeTable').addClass('add-scroll');
          //       }
          //     });
          //   } else {
          //     $('#myCommitteeTable').removeClass('add-scroll');
          //   }
          // }
        } else {
          this.setState({
            isRequestLoader: false
          })
        }
      })
      .catch((error) => {
        console.log(error);
        // this.state.isRequestFailed = true;
        this.state.isRequestLoader = false;
        logoutFunction(error?.response?.status);
        swal("Error!", "Something went wrong. Please try again.", "warning");
        // toast.error("Failed to load.", { position: toast.POSITION.TOP_RIGHT, color: "#fff", })
      });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }

    if (window.innerWidth < 900) {
      this.state.isMobile900 = true;
    } else {
      this.state.isMobile900 = false;
    }

    if (window.innerWidth < 350) {
      this.state.isMobile350 = true;
    } else {
      this.state.isMobile350 = false;
    }

    if (window.innerWidth < 650) {
      this.state.isMobile650 = true;
    } else {
      this.state.isMobile650 = false;
    }

    if (window.innerWidth < 450) {
      this.state.isMobile450 = true;
    } else {
      this.state.isMobile450 = false;
    }

    if (window.innerWidth < 450) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }
    this.state.height = window.innerHeight;
    this.state.width = window.innerWidth;
    this.setState({});
  };

  sortTable = (name) => {
    this.state.isRequestLoader = true;
    let sortData = this.state.skillMatrixList;
    if (sortData && sortData.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc"
          this.state.order = ordernew;
        }
        else {
          var ordernew = "asc"
          this.state.order = ordernew;
        }
      }
      else {
        this.state.sortBy = name;
        this.state.order = 'asc'
      }
      this.setState({ currentPage: 1 }, () => {
        this.getMainRoleSkillMatrix()
      })
      // this.getMainRoleSkillMatrix()
    }
  };

  sortTable1 = (name) => {
    this.state.isRequestLoader = true;
    let sortData1 = this.state.supportingRolesList;
    if (sortData1 && sortData1.length !== 0) {
      if (this.state.sortBy1 === name) {
        this.state.sortBy1 = name;
        if (this.state.order1 === "asc") {
          var ordernew1 = "desc"
          this.state.order1 = ordernew1;
        }
        else {
          var ordernew1 = "asc"
          this.state.order1 = ordernew1;
        }
      }
      else {
        this.state.sortBy1 = name;
        this.state.order1 = 'asc'
      }
      this.setState({ currentPage: 1 }, () => {
        this.getCommitteeRoleSkillMatrix()
      })
      // this.getCommitteeRoleSkillMatrix()
    }
  };

  find = (e) => {
    if (this.state.mainRoleBorder == true && this.state.skillMatrixList?.length > 0) {
      this.state.isRequestLoader = true;
      this.state.perPageMr = e.value;
      this.state.paginListMainRole = e;
      // this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      const selectedPage = 1;
      this.state.currentPageMr = selectedPage;
      this.setState({}, () => {
        this.getMainRoleSkillMatrix();
      });
    }
    else if (this.state.supportroleBorder == true && this.state.supportingRolesList?.length > 0) {
      this.state.isRequestLoader = true;
      this.state.perPageCr = e.value;
      this.state.pagingListCommitteeRole = e;
      // this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      // this.state.currentPageCr = 1;
      this.setState({ currentPageCr: 1 }, () => {
        this.getCommitteeRoleSkillMatrix();
      });
    }

  };
  handlePageChange = (pageNumber) => {
    this.state.isRequestLoader = true;
    if (this.state.mainRoleBorder == true) {
      this.state.currentPageMr = pageNumber;
      this.setState({}, () => {
        this.getMainRoleSkillMatrix()
      });
    } else if (this.state.supportroleBorder == true) {
      this.state.currentPageCr = pageNumber;
      this.setState({}, () => {
        this.getCommitteeRoleSkillMatrix()
      });
    }
  }

  onchangeProficiecy = (e) => {
    this.state.proficiencyId = parseInt(e.value.split(",")[0]);
    this.state.proficiencyValue = e.value.split(",")[1];
    this.state.proficiencyNameEditShow = e;
    this.setState({});
  };

  onchangeProficiecyExpected = (e) => {
    this.state.proficiencyExpectedId = parseInt(e.value.split(",")[0]);
    this.state.proficiencyExpectedValue = e.value.split(",")[1];
    this.state.proficiencyExpectedNameEditShow = e;
    this.setState({});
  };

  onchangeJob = (e) => {
    // this.state.jobId = parseInt(e.value.split(",")[0]);
    this.state.JobNameValue = e.target.value;
    // this.state.jobNameEditShow = e;
    this.setState({});
  };

  onchangeLevel = (e) => {
    this.state.LevelId = parseInt(e.value.split(",")[0]);
    this.state.LevelNameValue = e.value.split(",")[1];
    this.state.levelNameEditShow = e;
    this.setState({});
  };

  onchangeSkill = (e) => {
    this.state.skillId = parseInt(e.value.split(",")[0]);
    this.state.skillNameValue = e.value.split(",")[1];
    this.state.skillNameEditShow = e;
    this.setState({});
  };


  openSearchFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById('searchScreen')
    );
    myOffcanvas.show();
    this.state.isSearch = true;
    $("body").addClass("scrollhide");
  }

  searchSupportRoleList = () => {
    if (this.state.JobNameValue?.trim() !== "" || this.state.skillNameValue?.trim() !== "" || this.state.LevelNameValue?.trim() !== "" || this.state.proficiencyValue?.trim() !== "" || this.state.proficiencyExpectedValue?.trim() !== "") {
      this.state.searchData = {
        job: this.state.JobNameValue || null,
        skillId: this.state.skillId || 0,
        skill: this.state.skillNameValue || null,
        levelId: this.state.LevelId || 0,
        level: this.state.LevelNameValue || null,
        proficiencyExpectedId: this.state.proficiencyExpectedId || 0,
        proficiencyExpected: this.state.proficiencyExpectedValue || null,
        proficiencyId: this.state.proficiencyId || 0,
        proficiency: this.state.proficiencyValue || null
      }
      this.state.isFieldEmpty = false;
      $("#searchScreen").removeClass("show");
      $("body").removeClass("scrollhide");
      if (this.state.searchRole == "mainrole") {
        this.getMainRoleSkillMatrix();
      } else if (this.state.searchRole == "supportrole") {
        this.getCommitteeRoleSkillMatrix();
      }
    } else {
      this.state.isFieldEmpty = true;
    }

  }

  clearSearchFields = () => {
    this.state.searchData = {};
    this.state.skillNameValue = "";
    this.state.JobNameValue = "";
    this.state.LevelNameValue = "";
    this.state.proficiencyValue = "";
    this.state.proficiencyExpectedValue = "";
    this.state.proficiencyNameEditShow = "";
    this.state.skillNameEditShow = "";
    this.state.levelNameEditShow = "";
    this.state.jobNameEditShow = "";
    this.state.skillId = 0;
    this.state.LevelId = 0;
    this.state.proficiencyId = 0;
    this.state.proficiencyExpectedId = 0;
    this.getMainRoleSkillMatrix();
    this.getCommitteeRoleSkillMatrix();
    this.setState({});
  }

  closeSearch = () => {
    $("body").removeClass("scrollhide");
  };

  filterMainCommitteeRoles = () => {
    $('body').addClass("scrollhide");
    $("#mainCommitteeRolesModal").addClass("show");
  };

  searchFilterData = (obj) => {
    let hasActive = $("#MainRoles-tab").hasClass("active");
    if (hasActive == true) {
      this.setState({
        sortBy: 'jobGroup',
        order: 'asc',
        currentPageMr: 1,
        searchMainSupportRoles: obj
      }, () => {
        this.getMainRoleSkillMatrix(obj);
      })
    } else {
      this.setState({
        sortBy1: 'jobGroup',
        order1: 'asc',
        currentPageCr: 1,
        searchMainSupportRoles: obj
      }, () => {
        this.getCommitteeRoleSkillMatrix(obj);
      })
    }
  }

  clearFilterData = (obj) => {
    let hasActive = $("#MainRoles-tab").hasClass("active");
    if (hasActive == true) {
      this.setState({
        sortBy: 'jobGroup',
        order: 'asc',
        currentPageMr: 1,
        searchMainSupportRoles: obj
      }, () => {
        this.getMainRoleSkillMatrix(obj);
      })
    } else {
      this.setState({
        sortBy1: 'jobGroup',
        order1: 'asc',
        currentPageCr: 1,
        searchMainSupportRoles: obj
      }, () => {
        this.getCommitteeRoleSkillMatrix(obj);
      })
    }
  }

  clearFilterData1 = (obj) => {
    let hasActive = $("#MainRoles-tab").hasClass("active");
    if (hasActive == true) {
      this.setState({
        sortBy: 'jobGroup',
        order: 'asc',
        currentPageMr: 1,
        searchMainSupportRoles: obj
      })
    } else {
      this.setState({
        sortBy1: 'jobGroup',
        order1: 'asc',
        currentPageCr: 1,
        searchMainSupportRoles: obj
      })
    }
  }

  searchMainRole = () => {
    this.setState({ mainRoleBorder: true, supportroleBorder: false });
    if (this.state.mainRoleBorder !== true) {
      this.setState({ sortBy: "mastery", perPageMr: 20, pageCountMr: 1, paginListMainRole: [{ "label": "20", "value": 20 }] },
        () => { this.getMainRoleSkillMatrix(); }
      )
    }

  }

  searchSupportRole = () => {
    this.setState({ mainRoleBorder: false, supportroleBorder: true });
    if (this.state.supportroleBorder !== true) {
      this.setState({ sortBy: "mastery", perPageCr: 20, pageCountCr: 1, pagingListCommitteeRole: [{ "label": "20", "value": 20 }] },
        () => { this.getCommitteeRoleSkillMatrix(); }
      )
    }

  }

  render() {
    const {
      sortBy,
      order,
      order1,
      sortBy1,
      isRequestFailed,
      isRequestLoader,
      paginglist,
      paginglistDefault,
      pageCount,
      pageCountCr,
      pageCountMr,
      currentUser,
      skillMatrixList,
      supportingRolesList,
      width,
      isMobile,
      isMobile450,
      isMobile350,
      isMobile650,
      isMobile900,
      iswebMobile,
      mainRoleBorder,
      supportroleBorder,
      paginListMainRole,
      pagingListCommitteeRole,
    } = this.state;
    let { menuToggle } = this.props;

    return (
      <>

        {$("#courseQuestionnaireScreen").hasClass("show") ||
          $("#pendingCertificateScreen").hasClass("show") ? (
          <div
            className="viewbar-overlay"
            onClick={() => this.closeProperties()}
          ></div>
        ) : (
          <></>
        )}

        <div
          className={`${isMobile
            ? "main-body-mobile table-responsive-xl"
            : menuToggle
              ? "menu-main-body table-responsive-xl"
              : "main-body table-responsive-xl"
            } `}
        >
          <LoaderVisible isLoader={isRequestLoader} />
          {/* <LoaderFailed isLoader={isRequestFailed} /> */}
          <div className="head-fixed">

            {isMobile == true ? (
              <div className="mobile-head border-bottom w-100">
                <div className="col-12 mobile-title">{"Capability chart"}</div>
              </div>
            ) : (
              <div className="title">
                <>
                  <CommonIcon fileName="Skillmatrixicon" />
                  <span className="pl-10 head-span">Capability chart</span>
                </>
              </div>
            )}
          </div>

          {/* New Matrix */}

          {
            this.state.isPieChart &&
            <>
              <div className="mb-5">
                <div
                  className={` ${isMobile ? "skill-matrix-mobile" : "skill-matrix  "
                    }  px-4  pb-20 text-20-bold no-wrap min-width-circle `}
                >
                  My job skills & competency
                </div>
                <div className="d-block width-fit-content">
                  <div className=" mt-2 mx-2" id="chart">
                    <Chart
                      options={this.state?.options}
                      series={this.state.graphDataValue ?
                        this.state.series?.map(item => item.label)
                        : [0, 0, 0, 0, 0, 100]}
                      type="pie"
                      width="250"
                      height="250"
                    />
                  </div>
                  {
                    this.state.graphDataValue ?
                      <div className="display-block legend">
                        {
                          (this.state.series.map((item, index) => (
                            <div className="display-flex no-wrap mb-1"><div className="square mt-10" style={{ backgroundColor: this.state.options.colors[index] }}></div> <div className="mt-1 mx-2 min-width-legend display-flex"> {this.state.options.labels[index]}
                              <div className="tooltip">
                                <InfoIcon className="info-icon"></InfoIcon>
                                <span class={`${this.state.options.labels[index] == "NA" ? 'tooltip-na' : ''} tooltiptext text-12-normal`}>{item.description}</span>
                              </div>
                            </div><span className="mx-5">{item.label + "%"}</span></div>
                          )))
                        }
                      </div>
                      :
                      <div className="display-block legend-team-nodata">
                        <div className="display-flex no-wrap"><div className="square mt-10" style={{ backgroundColor: "#D3D3D3" }}></div> <div className="mt-1 mx-2 min-width-legend"> No records </div></div>

                      </div>
                  }

                </div>
              </div>
            </>
          }

          {/* Tabs */}

          <div className={`${this.state.graphDataValue ? 'mt-15' : 'mt-30'} common-table-bottom table-responsive table-responsive-scroll col-12 margin-bottom-table`}>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item nav-main" role="presentation">
                <button class={`active tabsButton cursor-pointer`} id="MainRoles-tab" data-bs-toggle="tab" data-bs-target="#MainRoles" type="button" role="tab" aria-controls="MainRoles" aria-selected="true" onClick={() => this.searchMainRole()} ><span className={`${mainRoleBorder ? 'border-bottom-red padBottom text-danger' : ''}`}>Main roles</span></button>
              </li>
              <li class="nav-item" role="presentation">
                <button class={`tabsButton cursor-pointer`} id="CommitteeRoles-tab" data-bs-toggle="tab" data-bs-target="#CommitteeRoles" type="button" role="tab" aria-controls="CommitteeRoles" aria-selected="false" onClick={() => this.searchSupportRole()}><span className={` ${supportroleBorder ? 'border-bottom-red padBottom text-danger' : ''}`}>Committee roles</span></button>
              </li>
              <div className="filter-icon filter-icon-position text-align-end">
                <span className="cursor-pointer" onClick={this.filterMainCommitteeRoles}>
                  <CommonIcon fileName="filterIcon" />
                </span>
              </div>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="MainRoles" role="tabpanel" aria-labelledby="MainRoles-tab">
                <div className="table-responsive table-responsive-scroll">
                  {/* <div
                        className={` ${isMobile ? "skill-matrix-mobile" : "skill-matrix  "
                          } px-4  pb-20 text-20-bold `}
                      >
                        <span>Job/Task</span>{" "}
                      </div> */}
                  <div>
                    {/* <div className="" > */}
                    <div id="myTable" className="table-fixed-header minheight-33vh">
                      <table className="table fileListTable2 table-borderless" id="results">
                        <thead id="skillMatrix">
                          <tr>
                            <td></td>
                            <td
                              className="cursor-pointer "
                              onClick={() => this.sortTable("jobGroup")}>
                              <span> Job group </span>
                              {sortBy === "jobGroup" && (
                                <CommonIcon

                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer "
                              onClick={() => this.sortTable("jobName")}>
                              <span> Job/Task </span>
                              {sortBy === "jobName" && (
                                <CommonIcon

                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>

                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable("skillName")}
                            >
                              <span> Skills </span>
                              {sortBy === "skillName" && (
                                <CommonIcon
                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable("levelName")}
                            >
                              <span> Level </span>
                              {sortBy === "levelName" && (
                                <CommonIcon
                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable("expectedProficiency")}
                            >
                              <span> Proficiency expected </span>
                              {sortBy === "expectedProficiency" && (
                                <CommonIcon
                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable("proficiency")}
                            >
                              <span> Proficiency </span>
                              {sortBy === "proficiency" && (
                                <CommonIcon
                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable("mastery")}
                            >
                              <span> Outstanding </span>
                              {sortBy === "mastery" && (
                                <CommonIcon
                                  fileName={order === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                          </tr>
                        </thead>
                        <tbody >
                          {skillMatrixList?.length > 0 ? (
                            skillMatrixList.map((item, index) => (
                              <tr id={"active" + item.skillMatrixId} key={index}>
                                <td className="cursor-default"></td>
                                <td className="cursor-default min-width-jobtask">
                                  <span>{item.jobGroup}</span>
                                </td>
                                <td className="cursor-default min-width-jobtask">
                                  <span>{item.jobName}</span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  <span>{item.skillName}</span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  <span>{item.levelName}</span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  <span>{item.expectedProficiency}</span>
                                </td>
                                <td className="min-width-skills">
                                  <span
                                    className={` ${(item.proficiency == "Competent" ? "blue-color" : item.proficiency == "Master" ? "green-color" :
                                      item.proficiency == "Learner" ? "orange-color" :
                                        item.proficiency == "Novice" ? "yellow-color"
                                          : "brown-color"
                                    )
                                      } cursor-default `}
                                  >
                                    {(item.proficiency == "") ? "NA" : item.proficiency}
                                  </span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  {item.mastery >= 1 && (
                                    <CommonIcon fileName="staricon" />
                                  )}
                                  {item.mastery >= 2 && (
                                    <CommonIcon fileName="staricon" />
                                  )}
                                  {item.mastery >= 3 && (
                                    <CommonIcon fileName="staricon" />
                                  )}
                                </td>
                              </tr>
                              //   ${ ( item.proficiency == "competent" || "master" ) ? "green-color" : "yellow-color" }
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center table-nodata">
                                {"No record found"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* <div
                      className={`${isMobile ? "mobile-pagination-skill1"
                        : menuToggle ? "sidemenu-pagination-skillmatrix" : "web-pagination-skillmatrix"} pb-2 pt-2`}>

                      <table width="100%">
                        <tbody>
                          <tr>
                            <td width="8%" className="p-3">
                              <div className={`${iswebMobile ? "mobilePageSelect" : "webpageSelect"}`}>
                                <Select
                                  options={paginglist}
                                  defaultValue={paginglistDefault}
                                  classNamePrefix="paging"
                                  isSearchable={false}
                                  menuPlacement={"top"}
                                  menuPosition={"fixed"}
                                  onChange={(e) => this.find(e, "MainRole")}
                                />
                              </div>
                            </td>
                            <td width="92%" className="text-end p-3">
                              {isMobile ?
                                <Pagination
                                  prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                                  nextPageText={<>   <CommonIcon fileName="RightArrowIcon" /></>}
                                  linkClassNext="nextArrow"
                                  linkClassPrev="prevArrow"
                                  itemClass={`page-item`}
                                  linkClass="page-link"
                                  pageRangeDisplayed={1}
                                  onChange={e => this.handlePageChange(e, "MainRole")}
                                  activePage={this.state.currentPageMr}
                                  totalItemsCount={this.state.pageCountMr}
                                  itemsCountPerPage={this.state.perPageMr}
                                /> :
                                <Pagination
                                  prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                                  nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                                  linkClassNext="nextArrow"
                                  linkClassPrev="prevArrow"
                                  itemClass={`page-item`}
                                  linkClass="page-link"
                                  pageRangeDisplayed={4}
                                  onChange={e => this.handlePageChange(e, "MainRole")}
                                  activePage={this.state.currentPageMr}
                                  totalItemsCount={this.state.pageCountMr}
                                  itemsCountPerPage={this.state.perPageMr}
                                />}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> */}
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="CommitteeRoles" role="tabpanel" aria-labelledby="CommitteeRoles-tab">
                <div className="table-responsive table-responsive-scroll">
                  {/* <div className={`px-4 pt-20 pb-20 text-20-bold `}>
                        Committee roles
                      </div> */}
                  <div className="" >
                    <div id="myCommitteeTable" className="table-fixed-header minheight-33vh">
                      <table className="table fileListTable2 table-borderless" id="resultsTable">
                        <thead id="skillMatrix">
                          <tr>
                            <td></td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("jobGroup")}>
                              <span> Job group </span>
                              {sortBy1 === "jobGroup" && (
                                <CommonIcon

                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("jobName")}>
                              <span> Job/Task </span>
                              {sortBy1 === "jobName" && (
                                <CommonIcon

                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>

                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("skillName")}
                            >
                              <span> Skills </span>
                              {sortBy1 === "skillName" && (
                                <CommonIcon
                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("levelName")}
                            >
                              <span> Level </span>
                              {sortBy1 === "levelName" && (
                                <CommonIcon
                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("expectedProficiency")}
                            >
                              <span> Proficiency expected </span>
                              {sortBy1 === "expectedProficiency" && (
                                <CommonIcon
                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("proficiency")}
                            >
                              <span> Proficiency </span>
                              {sortBy1 === "proficiency" && (
                                <CommonIcon
                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() => this.sortTable1("mastery")}
                            >
                              <span> Outstanding </span>
                              {sortBy1 === "mastery" && (
                                <CommonIcon
                                  fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                                />
                              )}
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {supportingRolesList?.length > 0 ? (
                            supportingRolesList.map((item, index) => (
                              <tr id={"active" + item.skillMatrixId} key={index}>
                                <td className="cursor-default"></td>
                                <td className="cursor-default min-width-jobtask">
                                  <span>{item.jobGroup}</span>
                                </td>
                                <td className="cursor-default min-width-jobtask">
                                  <span>{item.jobName}</span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  <span>{item.skillName}</span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  <span>{item.levelName}</span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  <span>{item.expectedProficiency}</span>
                                </td>
                                <td className="min-width-skills">
                                  <span
                                    className={` ${(item.proficiency == "Competent" ? "blue-color" : item.proficiency == "Master" ? "green-color" :
                                      item.proficiency == "Learner" ? "orange-color" :
                                        item.proficiency == "Novice" ? "yellow-color"
                                          : "brown-color"
                                    )
                                      } cursor-default `}
                                  >
                                    {(item.proficiency?.trim() == "") ? "NA" : item.proficiency}
                                  </span>
                                </td>
                                <td className="cursor-default min-width-skills">
                                  {item.mastery >= 1 && (
                                    <CommonIcon fileName="staricon" />
                                  )}
                                  {item.mastery >= 2 && (
                                    <CommonIcon fileName="staricon" />
                                  )}
                                  {item.mastery >= 3 && (
                                    <CommonIcon fileName="staricon" />
                                  )}
                                </td>
                              </tr>
                              //   ${ ( item.proficiency == "competent" || "master" ) ? "green-color" : "yellow-color" }
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center table-nodata">
                                {"No record found"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table></div>
                    {/* <div
                      className={`${isMobile ? "mobile-pagination-skill1"
                        : menuToggle ? "sidemenu-pagination-skillmatrix" : "web-pagination-skillmatrix"} pb-2 pt-2`}>

                      <table width="100%">
                        <tbody>
                          <tr>
                            <td width="8%" className="p-3">
                              <div className={`${iswebMobile ? "mobilePageSelect" : "webpageSelect"}`}>
                                <Select
                                  options={paginglist}
                                  defaultValue={paginglistDefault}
                                  classNamePrefix="paging"
                                  isSearchable={false}
                                  menuPlacement={"top"}
                                  menuPosition={"fixed"}
                                  onChange={(e) => this.find(e, "CommitteeRole")}
                                />
                              </div>
                            </td>
                            <td width="92%" className="text-end p-3">
                              {isMobile ?
                                <Pagination
                                  prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                                  nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                                  linkClassNext="nextArrow"
                                  linkClassPrev="prevArrow"
                                  itemClass={`page-item`}
                                  linkClass="page-link"
                                  pageRangeDisplayed={1}
                                  onChange={e => this.handlePageChange(e, "CommitteeRole")}
                                  activePage={this.state.currentPageCr}
                                  totalItemsCount={this.state.pageCountCr}
                                  itemsCountPerPage={this.state.perPageCr}
                                /> :
                                <Pagination
                                  prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                                  nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                                  linkClassNext="nextArrow"
                                  linkClassPrev="prevArrow"
                                  itemClass={`page-item`}
                                  linkClass="page-link"
                                  pageRangeDisplayed={4}
                                  onChange={e => this.handlePageChange(e, "CommitteeRole")}
                                  activePage={this.state.currentPageCr}
                                  totalItemsCount={this.state.pageCountCr}
                                  itemsCountPerPage={this.state.perPageCr}
                                />}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> */}
                  </div>
                </div>
              </div>

            </div>


          </div>
          {/* end Tabs */}


        </div>
        {/* End New Matrix */}


        {/* <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchScreen" aria-labelledby="offcanvasScrollingLabel">
          <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
            <h6 id="offcanvasRightLabel" className="modal-title">Search</h6>
            <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas" onClick={this.closeSearch}>
              <CommonIcon fileName="CrossIcon" />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                      <label
                        className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                        <CommonIcon className="properties-img-2" fileName="jobicon" />
                        <span className="pl-5 properties-search-span">
                          Job
                        </span>
                      </label>

                      <input type="text"
                        className={`form-control form-text-box my-input-class  `}
                        //  className={`form-control form-text-box my-input-class ${isJobEmpty && "border-red"} `} 
                        // style={{ "border-radius": "0" ,  borderColor: this.state.isJobEmpty ? "#d12232" : ""}}
                        placeholder="" value={this.state.JobNameValue} onChange={(e) => this.onchangeJob(e)}
                        required />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                      <label
                        className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                        <CommonIcon className="properties-img-2" fileName="skillIcon" />
                        <span className="pl-5 properties-search-span">
                          Skills
                        </span>
                      </label>
                      <Select
                        className={` text-12-normal my-input-class   `}
                        // className={` text-12-normal my-input-class  ${isSkillEmpty && 'border-red'}  `}
                        classNamePrefix="assigngroups"
                        value={this.state.skillNameEditShow}
                        options={this.state.skillsList}
                        defaultValue={"Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={this.onchangeSkill}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                      <label
                        className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                        <CommonIcon className="properties-img-2" fileName="levelIcon" />
                        <span className="pl-5 properties-search-span">
                          Level
                        </span>
                      </label>
                      <Select
                        className={` text-12-normal my-input-class    `}
                        // className={` text-12-normal my-input-class  ${isLevelEmpty && 'border-red'}  `}
                        classNamePrefix="assigngroups"
                        value={this.state.levelNameEditShow}
                        options={this.state.levelList}
                        defaultValue={"Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={this.onchangeLevel}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                      <label
                        className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                        <CommonIcon className="img-width-15" fileName="proficiencyExpected" />
                        <span className="pl-5 properties-search-span">
                          Proficiency expected
                        </span>
                      </label>
                      <Select
                        className={` text-12-normal my-input-class   `}
                        //  className={` text-12-normal my-input-class  ${isProficiencyEmpty && 'border-red'}  `}
                        classNamePrefix="assigngroups"
                        value={this.state.proficiencyExpectedNameEditShow}
                        options={this.state.proficiencyList}
                        defaultValue={"Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={this.onchangeProficiecyExpected}
                      />
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                      <label
                        className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                        <CommonIcon className="img-width-15" fileName="proficiencyExpected" />
                        <span className="pl-5 properties-search-span">
                          Proficiency
                        </span>
                      </label>
                      <Select
                        className={` text-12-normal my-input-class   `}
                        //  className={` text-12-normal my-input-class  ${isProficiencyEmpty && 'border-red'}  `}
                        classNamePrefix="assigngroups"
                        value={this.state.proficiencyNameEditShow}
                        options={this.state.proficiencyList}
                        defaultValue={"Select"}
                        isClearable={true}
                        isMulti={false}
                        isSearchable={true}
                        onChange={this.onchangeProficiecy}
                      />
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
            {/* {(isSkillEmpty || isJobEmpty || isLevelEmpty || isProficiencyEmpty) ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)} */}
        {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              <div className="d-flex">
                <button className="btn rejectbutton" onClick={() => this.clearSearchFields()}><CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" /><span className="px-1">Clear</span></button>
                <button className="btn approvebutton mx-2" onClick={() => this.searchSupportRoleList()}><CommonIcon className="button-img" fileName="searchIcon" /><span className="pl-10">Search</span></button>
              </div>
            </div>
          </div> */}
        {/* // </div> */}
        {/* <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={ this.state.mainRoleBorder == true ? pageCountMr : pageCountCr} /> */}
        {
          (this.state.mainRoleBorder ? (this.state.pageCountMr > 0) : (this.state.pageCountCr > 0)) && (
            <>

              <div
                className={`${isMobile ? "common-mobilesubmenu mobile-pagination"
                  : menuToggle ? "common-submenu sidemenu-pagination" : "common-submenu web-pagination"} pb-2 pt-2`}>

                <table width="100%">
                  <tbody>
                    <tr>
                      <td width="8%" className="p-3">
                        <div id="perPage" className={`${iswebMobile ? "mobilePageSelect" : "webpageSelect"}`}>
                          <Select
                            options={paginglist}
                            defaultValue={paginglistDefault}
                            value={this.state.mainRoleBorder ? this.state.paginListMainRole : this.state.pagingListCommitteeRole}
                            classNamePrefix="paging"
                            isSearchable={false}
                            menuPlacement={"top"}
                            menuPosition={"fixed"}
                            onChange={(e) => this.find(e)}
                          />
                        </div>
                      </td>
                      <td width="92%" className="text-end p-3">
                        {isMobile ?
                          <Pagination
                            prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                            nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                            linkClassNext="nextArrow"
                            linkClassPrev="prevArrow"
                            itemClass={`page-item page-width-mobile`}
                            linkClass="page-link"
                            pageRangeDisplayed={1}
                            onChange={e => this.handlePageChange(e)}
                            activePage={this.state.mainRoleBorder ? this.state.currentPageMr : this.state.currentPageCr}
                            totalItemsCount={this.state.mainRoleBorder ? this.state.pageCountMr : this.state.pageCountCr}
                            itemsCountPerPage={this.state.mainRoleBorder ? this.state.perPageCr : this.state.perPageCr}
                          /> :
                          <Pagination
                            prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                            nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                            linkClassNext="nextArrow"
                            linkClassPrev="prevArrow"
                            itemClass={`page-item page-width`}
                            linkClass="page-link"
                            pageRangeDisplayed={4}
                            onChange={e => this.handlePageChange(e)}
                            activePage={this.state.mainRoleBorder ? this.state.currentPageMr : this.state.currentPageCr}
                            totalItemsCount={this.state.mainRoleBorder ? this.state.pageCountMr : this.state.pageCountCr}
                            itemsCountPerPage={this.state.mainRoleBorder ? this.state.perPageMr : this.state.perPageCr}
                          />}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>)
        }
        <SkillMatrixFilter
          isMobile={this.state.isMobile}
          searchFilterData={(obj) => this.searchFilterData(obj)}
          isMainRole={$("#MainRoles-tab").hasClass("active") == true ? true : false}
          clearFilterData={(obj) => this.clearFilterData(obj)}
          clearFilterData1={(obj) => this.clearFilterData1(obj)}
        />
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Skillmatrix);
